import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const CommunicationTypeStaffPage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'type', label: 'Communication Type' },
    { key: 'description', label: 'Description' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'Code', type: 'text', required: true },
    { key: 'type', label: 'Communication Type', type: 'text', required: true },
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: 'EMAIL', type: 'Email', description: 'Communication via email', active: 'Yes' },
    { id: '2', code: 'PHONE', type: 'Phone Call', description: 'Communication via phone call', active: 'Yes' },
    { id: '3', code: 'TEXT', type: 'Text Message', description: 'Communication via SMS/text', active: 'Yes' },
    { id: '4', code: 'FAX', type: 'Fax', description: 'Communication via fax', active: 'Yes' },
    { id: '5', code: 'MEET', type: 'In-Person Meeting', description: 'In-person meeting or conference', active: 'Yes' },
    { id: '6', code: 'VIDEO', type: 'Video Conference', description: 'Video call/telehealth', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Communication Type for Staff"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Type"
      formFields={formFields}
      apiEndpoint="/setup/communication-type-staff"
    />
  );
};

export default CommunicationTypeStaffPage;
